/**
 * §6.10 — how each buying-signal id reads back to the rep.
 *
 * The ids themselves come from the pack (`config.buyingSignals`), so a pack may
 * name a signal this map does not cover. That renders nothing rather than
 * guessing: an unexplained label teaches less than no label at all.
 *
 * These sentences are deliberately about the *shape* of a question and never
 * about a product, a price or a client's process — the vocabulary is the
 * platform's, the questions are the pack's (§17.3).
 */
export const SIGNAL_COPY: Record<string, string> = {
  genuine: 'a genuine buying question — asked from the other side of the decision. Answer it and stop talking.',
  stall: 'a stall — it defers the decision rather than moving toward it.',
  diversion: 'a diversion — it moves the call off the decision and onto something else. Answer it briefly, then come back.',
  depends: 'one that reads either way. What came before it decides which.',
};

/** The sentence for a signal, or null when the pack names one we cannot explain. */
export function signalCopy(id: string | undefined): string | null {
  return (id && SIGNAL_COPY[id]) || null;
}
